export * from "ce/pages/AdminSettings/LeftPane";
import { default as CE_LeftPane } from "ce/pages/AdminSettings/LeftPane";
export default CE_LeftPane;
